import React from 'react'

import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import VotingPlayer from './VotingPlayer'

const styles = (theme) => ({
  heading: {
    backgroundColor: theme.palette.secondary.main,
    color: '#ffffff',
  },
  headingTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  content: {
    flex: 1,
  },
  field: {
    marginBottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  player: {
    display: 'flex',
    height: 768,
    [theme.breakpoints.down('md')]: {
      height: 512,
    },
    [theme.breakpoints.down('sm')]: {
      height: 384,
    },
    [theme.breakpoints.down('xs')]: {
      height: 256,
    },
  },
})
const useStyles = makeStyles(styles)

export default function VotingPlayerInfo(props) {
  const { authorizationToken, deckId, title, recordingId } = props

  const classes = useStyles()

  return (
    <Accordion expanded>
      <AccordionSummary className={classes.heading}>
        <Typography className={classes.headingTitle}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <div className={classes.content}>
          {deckId && recordingId && (
            <div className={classes.player}>
              <VotingPlayer
                authorizationToken={authorizationToken}
                deckId={deckId}
                recordingId={recordingId}
              />
            </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
